// src/pages/Updates.js
import React from "react";
import "../styles/Updates.css";

const Updates = () => {
  const updates = [
    {
      title: "🤝 Official Collaboration with MINEMAKER!",
      description:
        "We’re thrilled to announce our collaboration with popular creator MINEMAKER! Expect exciting joint content, livestreams, and community growth. Join the hype on Discord!",
      date: "June 5, 2025 – 9:48 AM",
    },
    {
      title: "🌍 RixxyMC Survival SMP Officially Launched!",
      description:
        "The brand new Survival SMP is now live! Experience peaceful building, economy, land claims, and community vibes. Your long-term survival journey begins now!",
      date: "June 24, 2025",
    },
    {
      title: "⚔️ Practice PvP Server is LIVE!",
      description:
        "Sharpen your skills in our brand new Practice PvP server! Duel friends, train combos, and prepare for events with smooth PvP and multiple arenas.",
      date: "June 25, 2025",
    },
    {
      title: "🩸 Lifesteal Season 3 – Coming Soon!",
      description:
        "A new Lifesteal season is almost here! Expect fresh updates, better performance, new ranks, and intense PvP action. Season 3 will be the biggest one yet!",
      date: "June 25, 2025",
    },
    {
      title: "🎉 RixxyMC v1.0 is Here!",
      description:
        "We proudly launched RixxyMC — a next-gen Minecraft server built for the Indian community. Featuring crossplay support, unique gameplay mechanics, and a thriving Discord!",
      date: "November 29, 2024",
    },
    {
      title: "🆓 Cracked + Premium Now Supported",
      description:
        "No Minecraft account? No problem! RixxyMC now supports cracked launchers while keeping premium features and anti-cheat protection intact.",
      date: "November 29, 2024",
    },
    {
      title: "🛡️ Lifesteal Season Started Strong!",
      description:
        "Season 02 was a blast! We've optimized ping, added new commands, and rewarded active players with custom kits and perks. More to come!",
      date: "November 29, 2024",
    },
    {
      title: "🎁 Vote Rewards & Giveaways",
      description:
        "Vote daily to earn coins, kits, claim blocks, and exclusive in-game loot. New giveaways announced every week on Discord!",
      date: "December 10, 2024",
    },
  ];

  return (
    <div className="updates-page">
      <header className="updates-header">
        <h1>📢 RixxyMC <span className="highlight">News & Updates</span></h1>
        <p className="tagline">Stay updated with the latest from India's most loved Minecraft server!</p>
      </header>

      <div className="updates-grid">
        {updates.map((update, index) => (
          <div className="update-card" key={index}>
            <div className="card-header">
              <h3>{update.title}</h3>
              <span className="update-date">{update.date}</span>
            </div>
            <p className="update-description">{update.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Updates;
